import { TaskStatus } from './types_deprecated';

const base = 'task-center' as const;

/**
 * @deprecated
 */
export const taskCenterQueryKeys: Record<TaskStatus, [typeof base, keyof typeof TaskStatus]> = {
  [TaskStatus.STATUS_TODO]: [base, TaskStatus.STATUS_TODO],
  [TaskStatus.STATUS_IN_PROGRESS]: [base, TaskStatus.STATUS_IN_PROGRESS],
  [TaskStatus.STATUS_COMPLETED]: [base, TaskStatus.STATUS_COMPLETED],
  [TaskStatus.STATUS_UNKNOWN]: [base, TaskStatus.STATUS_UNKNOWN],
  [TaskStatus.STATUS_DELETED]: [base, TaskStatus.STATUS_DELETED],
};
